<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/tickets";

export default {
  name: 'TicketCreateModal',
  extends: ModelCreateModal,
  props: {
    modalTitle: {default() { return this.lodash.startCase(this.$t('create {something} new', {something: this.$t('tickets.singular')})) }},
    resourceRoute: {default: 'tickets'},
    modelVariable: {default: 'ticket'},
    form: {default() { return FormsModel; }},
    size: {default: 'md'},
  },
  methods: {
    store(value) {
      this.loading = true
      return this.$axios.post('/tickets', value).finally(() => this.loading = false);
    }
  },
}
</script>

<style scoped>
  ::v-deep {
    .modal-header, .modal-footer {
      border: none;
    }
    .modal-header {
      padding-bottom: 0;
    }
    .modal-body {
      padding-block: 0;
    }
  }
</style>